<template>
  <div>
    <div class="columns">
      <div class="column is-4">
        <h1 class="title">Horas por proyecto</h1>
      </div>
      <div class="column">
        <div class="buttons">
          <button
            class="button"
            @click="findSummaryfiltrado(item)"
            v-for="(item, index) in empresas.list"
            :key="index"
            :class="empresaSelected === item ? 'is-link' : ''"
          >
            {{ empresas[item].name }}
          </button>
          <button
            class="button"
            :class="empresaSelected === 'todos' ? 'is-link' : ''"
            @click="findSummaryfiltrado('todos')"
          >
            Todos
          </button>
        </div>
      </div>
    </div>
    <y-graph :datagraph="grafica1" :cambio="cambio1" :height="80"></y-graph>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import yGraph from "@/components/dashboard/Graph.vue";
export default {
  data() {
    return {
      summary: [],
      grafica1: {},
      cambio1: 0,
      objectProjects: {},
      objectUserTask: {},
      empresas: { list: [] },
      empresaSelected: "todos",
    };
  },
  methods: {
    async findSummaryfiltrado(idempresa) {
      try {
        this.empresaSelected = idempresa;
        if (idempresa === "todos") {
          this.findSummary();
          return false;
        }
        const result = await apiServices.get(
          `/summaryprojectsfilter/${idempresa}`
        );
        if (result.data) {
          const _this = this;
          this.summary = [];
          for (let index in result.data) {
            const d = result.data[index];
            d.dataproject = _this.objectProjects[d._id.project];
            d.datausertask = _this.objectUserTask[d._id.assignedto];
            this.summary.push(d);
          }
          this.grafica1 = this.creagrafica(this.summary);
          this.cambio1++;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findSummary() {
      try {
        const result = await apiServices.get(`/summaryprojects`);
        if (result.data) {
          const _this = this;
          const result1 = await apiServices.get(`/projectlistall`);
          if (result1.data) {
            for (let index1 in result1.data) {
              const d1 = result1.data[index1];
              this.objectProjects[d1._id] = d1;
            }
          }
          const result2 = await apiServices.get(`/userstask`);
          if (result2.data) {
            for (let index2 in result2.data) {
              const d2 = result2.data[index2];
              this.objectUserTask[d2._id] = d2;
            }
          }
          this.summary = [];
          for (let index in result.data) {
            const d = result.data[index];
            d.dataproject = _this.objectProjects[d._id.project];
            d.datausertask = _this.objectUserTask[d._id.assignedto];
            this.summary.push(d);
          }
          this.grafica1 = this.creagrafica(this.summary);
          this.cambio1++;
        }
      } catch (err) {
        console.log(err);
      }
    },
    creagrafica(data) {
      // const colorTotal = "#3273dc";
      const colorTotal = "#d1d1d1";

      // const _this = this;
      const dataparagrafica = {
        typeGraphic: "bar",
        options: {
          legend: { position: "bottom", display: true },
        },
        colors: [
          "#3273dc",
          "#00d1b2",
          "#5c5aaf",
          "#00936e",
          "#e31782",
          "#112851",
          "#ec7460",
          "#97DCF4",
          "#6aa150",
          "#3273dc",
          "#00d1b2",
          "#5c5aaf",
          "#00936e",
          "#e31782",
          "#112851",
          "#ec7460",
          "#97DCF4",
          "#6aa150",
          "#3273dc",
          "#00d1b2",
          "#5c5aaf",
          "#00936e",
          "#e31782",
          "#112851",
          "#ec7460",
          "#97DCF4",
          "#6aa150",
          "#3273dc",
          "#00d1b2",
          "#5c5aaf",
          "#00936e",
          "#e31782",
          "#112851",
          "#ec7460",
          "#97DCF4",
          "#6aa150",
        ],
        datasetOverride: [{ type: "bar" }, { type: "bar" }, { type: "line" }],
        series: ["cosa", "cosa2", "cosa3"],
        labels: ["a", "b", "c", "d", "e"],
        data: [
          [65.6, 57.1, 63.4, 58, 62.6, 60],
          [70, 54, 61, 58, 46, 72],
          [65.6, 57.1, 63.4, 58, 62.6, 60],
        ],
      };

      const resumen = {
        list: [],
        total: {},
      };
      const copiacolors = JSON.parse(JSON.stringify(dataparagrafica.colors));
      const lengthempresas = JSON.parse(
        JSON.stringify(this.empresas.list.length)
      );

      const now = new Date();
      const year = now.getFullYear();
      const yeara = year - 1;
      for (let index = 1; index < 13; index++) {
        resumen.total[`${yeara}-${index}`] = 0;
      }
      for (let index = 1; index < 13; index++) {
        resumen.total[`${year}-${index}`] = 0;
      }
      for (let index in data) {
        const d = data[index];
        if (resumen.list.indexOf(d.dataproject._id) === -1) {
          resumen.list.push(d.dataproject._id);
          resumen[d.dataproject._id] = {
            name: d.dataproject.name,
            empresa: d.dataproject.empresa.nombrec,
          };
          if (lengthempresas === 0) {
            if (this.empresas.list.indexOf(d.dataproject.empresa._id) === -1) {
              this.empresas.list.push(d.dataproject.empresaproject._id);
              this.empresas[d.dataproject.empresaproject._id] = {
                name: d.dataproject.empresaproject.name,
                _id: d.dataproject.empresaproject._id,
              };
            }
          }
          for (let index1 = 1; index1 < 13; index1++) {
            resumen[d.dataproject._id][`${yeara}-${index1}`] = 0;
          }
          for (let index2 = 1; index2 < 13; index2++) {
            resumen[d.dataproject._id][`${year}-${index2}`] = 0;
          }
        }
        resumen[d.dataproject._id][`${d._id.year}-${d._id.mes}`] += d.horas;
        resumen["total"][`${d._id.year}-${d._id.mes}`] += d.horas;
      }
      const _this = this;
      this.empresas.list.sort(function (a, b) {
        if (_this.empresas[a].name < _this.empresas[b].name) {
          return 1;
        } else if (_this.empresas[a].name > _this.empresas[b].name) {
          return -1;
        } else {
          return 0;
        }
      });

      dataparagrafica.labels = [];
      dataparagrafica.data = [];
      dataparagrafica.series = [];
      dataparagrafica.datasetOverride = [];
      dataparagrafica.colors = [];
      for (let index = 1; index < 13; index++) {
        dataparagrafica.labels.push(`${yeara}-${index}`);
      }
      for (let index = 1; index < 13; index++) {
        dataparagrafica.labels.push(`${year}-${index}`);
      }
      resumen.list.sort(function (a, b) {
        if (resumen[a].empresa < resumen[b].empresa) {
          return 1;
        } else if (resumen[a].empresa > resumen[b].empresa) {
          return -1;
        } else {
          return 0;
        }
      });
      for (let index in resumen.list) {
        dataparagrafica.data.push([
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0,
        ]);
        dataparagrafica.series.push(resumen[resumen.list[index]].name);
        dataparagrafica.datasetOverride.push({ type: "bar" });
        dataparagrafica.colors.push(copiacolors[index]);
        for (let index1 in dataparagrafica.labels) {
          const lb = dataparagrafica.labels[index1];
          dataparagrafica.data[index][index1] =
            resumen[resumen.list[index]][lb];
        }
      }
      dataparagrafica.series.push("Total");
      dataparagrafica.data.push([
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ]);
      for (let index1 in dataparagrafica.labels) {
        const lb = dataparagrafica.labels[index1];
        dataparagrafica.data[dataparagrafica.series.length - 1][index1] =
          resumen["total"][lb];
      }
      dataparagrafica.datasetOverride.push({ type: "line" });
      dataparagrafica.colors.push(colorTotal);

      return dataparagrafica;
    },
  },
  created() {
    this.findSummary();
  },
  components: {
    yGraph,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/proyectos/reports/Reporttask.vue